import { render, staticRenderFns } from "./CobrancasTaxaFixa.vue?vue&type=template&id=51a69f8c&scoped=true"
import script from "./CobrancasTaxaFixa.vue?vue&type=script&lang=js"
export * from "./CobrancasTaxaFixa.vue?vue&type=script&lang=js"
import style0 from "./CobrancasTaxaFixa.vue?vue&type=style&index=0&id=51a69f8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a69f8c",
  null
  
)

export default component.exports